export const isValidDot = (text: string, index: number): boolean => {
  return index < text.length - 1 && ![' ', '\n'].includes(text[index + 1]);
};
